import React from 'react'

/**
 * GIS
 */
class GISMap extends React.Component {
  static propTypes = {
    county: React.PropTypes.string,
    pin: React.PropTypes.string,
  }

  render() {
    const {county, pin} = this.props

    let url = 'https://redi.mapping-online.com/redicomps/'
    if (county && pin) {
      url += `?county=${county}&pin=${pin}`
    }

    return (
      <iframe
        className="redi-component-gis-map"
        src={url}
        frameBorder="0"
      />
    )
  }
}

export default GISMap



// WEBPACK FOOTER //
// ./modules/shared/components/gisMap.js